import styled from 'styled-components';
import { theme } from '../../../theme';
import React, { PropsWithChildren } from 'react';
import { BodyText, BodyTextProps } from '../../typography';

const Error = styled(BodyText)`
  background-color: ${theme.colors.system.systemRedLite};
  border-radius: 2px;
  color: ${theme.colors.system.systemRed};
  padding: ${theme.spacings[2].rem} ${theme.spacings[3].rem};
`;

export const ErrorBox: React.FC<PropsWithChildren<BodyTextProps>> = ({
  children,
  ...props
}) => {
  return <Error {...props}>{children}</Error>;
};
